import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap';
import '../scss/custom.scss'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import Multiselect from 'vue-multiselect'

const app = createApp(App)

// Global components
app.component('multiselect', Multiselect)

// Toast main config
app.use(VueToast, {
  position: 'top',
  duration: 3000,
  dismissible	: true,
  queue: false,
  pauseOnHover: true
})

app.use(store)
app.use(router)
app.mount('#app')
